<script setup lang="ts">
    import { CreditCard } from '@/types';
    import { useI18n } from 'vue-i18n';
    import { computed, ref } from 'vue';
    import InputError from '@/components/InputError.vue';
    import SearchInput from '@/components/SearchInput.vue';
    import VoucherAdministrateCardFormItem from './VoucherAdministrateCardFormItem.vue';

    const { t } = useI18n();

    const props = defineProps<{
        form: any;
        employeeOptions: any;
        userOptions: any;
        isLoadingUserOptions?: boolean;
    }>();

    const searchTerm = ref('');

    const filteredCards = computed(() => {
        if (!searchTerm.value) {
            return props.form.cards;
        }

        return props.form.cards.filter(
            (card: CreditCard) =>
                card.name?.toLowerCase().includes(searchTerm.value.toLowerCase()) ||
                card.number?.toLowerCase().includes(searchTerm.value.toLowerCase()),
        );
    });
</script>

<template>
    <div class="space-y-4">
        <SearchInput
            v-model="searchTerm"
            :placeholder="t('vouchers.administrate.search')"
            class="w-full"
        />

        <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
            <InputError :message="form.errors.cards" />
            <VoucherAdministrateCardFormItem
                v-for="(card, index) in filteredCards"
                :key="card.id"
                :form="card"
                :main-form="form"
                :index="index"
                :employee-options="employeeOptions"
                :user-options="userOptions"
                :is-loading-user-options="isLoadingUserOptions"
            />

            <div
                v-if="filteredCards.length === 0 && form.cards.length > 0"
                class="text-muted-foreground col-span-full py-8 text-center text-xs"
            >
                <i18n-t
                    keypath="forms.no_results"
                    tag="span"
                    scope="global"
                >
                    <template #term>
                        <span class="font-bold">
                            {{ searchTerm }}
                        </span>
                    </template>
                </i18n-t>
            </div>
        </div>
    </div>
</template>
